import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Spinner, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate, useLocation } from "react-router-dom";

// Redux Actions
import {
  fetchTicket,
  replyTicket,
  closeTicket,
} from "../../slices/apps/ticketSlice";

// Child Components
import Section from "./Section";
import TicketDescription from "./TicketDescription";
import TicketDetailsRight from "./TicketDetails";

const TicketDetail = () => {
  document.title = "Talep Detayı | Global Yol Yardım";

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};

  const chatBottomRef = useRef(null);

  // Redux State
  const {
    ticket,
    ticketLoading,
    ticketRefresh,
    replyTicketLoading,
    closeTicketLoading,
  } = useSelector((state) => state.ticket);

  const [messageText, setMessageText] = useState("");

  // Veriyi Çek
  useEffect(() => {
    if (id) {
      dispatch(fetchTicket(id));
    }
  }, [dispatch, id, ticketRefresh]);

  useEffect(() => {
    if (chatBottomRef.current) {
      chatBottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [ticket?.Messages]);

  const handleSend = () => {
    if (!messageText.trim()) return;
    const values = {
      supportRequestId: id,
      message: messageText,
    };
    dispatch(replyTicket(values)).then((result) => {
      if (!result.error) {
        setMessageText("");
      }
    });
  };

  const handleCloseTicket = () => {
    dispatch(closeTicket(id));
  };

  // Helper Functions
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleString("tr-TR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getStatusBadgeColor = (status) => {
    switch (status) {
      case "Open":
        return "success";
      case "Closed":
        return "secondary";
      case "Pending":
        return "warning";
      default:
        return "primary";
    }
  };

  // Loading State
  if (ticketLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner color="primary" />
      </div>
    );
  }

  // Error State
  if (!ticket || !ticket.Id) {
    return (
      <Container fluid className="text-center mt-5">
        <h4>Talep bulunamadı veya bir hata oluştu.</h4>
        <Button color="primary" onClick={() => navigate(-1)}>
          Geri Dön
        </Button>
      </Container>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Section
              ticket={ticket}
              formatDate={formatDate}
              getStatusBadgeColor={getStatusBadgeColor}
              handleCloseTicket={handleCloseTicket}
              closeTicketLoading={closeTicketLoading}
            />
          </Row>
          <Row>
            <TicketDescription
              ticket={ticket}
              formatDate={formatDate}
              messageText={messageText}
              setMessageText={setMessageText}
              handleSend={handleSend}
              replyTicketLoading={replyTicketLoading}
              chatBottomRef={chatBottomRef}
            />
            <TicketDetailsRight
              ticket={ticket}
              formatDate={formatDate}
              getStatusBadgeColor={getStatusBadgeColor}
            />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TicketDetail;
